import React, { useEffect, useRef, useState } from 'react';
import RemoveModalTemplate from '@component/gridgio/modal/dialog-modal/remove-modal-template';
import { useTypedDispatch, useTypedSelector } from '@hook/common/useStore';
import { useRemovePlanMutation } from '@hook/gridgio/useApi';
import { actions as modalActions } from '@store/slice/gridgio/modal-slice';
import { isPlanRemoveModalDataType, type IPlanRemoveModalData } from '@datatype/gridgio/type';

interface IProps {
  data: IPlanRemoveModalData['data'];
}

const PlanRemoveModal: React.FC<IProps> = ({ data }) => {
  const dispatch = useTypedDispatch();
  const mutation = useRemovePlanMutation();
  const [errorMessage, setErrorMessage] = useState('');
  const dialogModalData = useTypedSelector((state) => state.rootReducer?.gridgioModalReducer?.dialogModalData) ?? null;
  const mountedRef = useRef(true);
  useEffect(() => {
    mountedRef.current = true;
    return () => {
      mountedRef.current = false;
    };
  }, []);
  const currentModalRef = useRef(dialogModalData);
  currentModalRef.current = dialogModalData;

  const handleCancel = () => {
    if (!mutation.isPending) dispatch(modalActions.hideModal());
  };
  const handleRemove = async () => {
    if (mutation.isPending) return;
    setErrorMessage('');
    try {
      await mutation.mutateAsync(data);
      const currentModal = currentModalRef.current;
      if (mountedRef.current && isPlanRemoveModalDataType(currentModal) && currentModal.data === data) {
        dispatch(modalActions.hideModal());
      }
    } catch {
      setErrorMessage('도면을 삭제하지 못했습니다. 다시 시도해주세요.');
    }
  };

  return (
    <RemoveModalTemplate
      title='도면을 삭제할까요?'
      description='이 도면을 사용 중인 작업은 유지됩니다.'
      errorMessage={errorMessage}
      isPending={mutation.isPending}
      handleCancel={handleCancel}
      handleRemove={() => void handleRemove()}
    />
  );
};

export default PlanRemoveModal;
